"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuaternaryButtonLink = exports.QuaternaryButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const primary_1 = require("./primary");
exports.QuaternaryButton = (0, styled_1.default)(primary_1.PrimaryButton) `
  &&& {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary')};
    &:focus,
    &:hover {
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary_hover')};
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary_hover')};
    }
    &:disabled {
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary_disabled')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_quaternary_disabled')};
    }
  }
`;
exports.QuaternaryButtonLink = (0, styled_1.default)((props) => (react_1.default.createElement(exports.QuaternaryButton, Object.assign({ as: "a" }, props)))) ``;
//# sourceMappingURL=quaternary.js.map